export const comparer = (a, b) => {
  return JSON.stringify(a) === JSON.stringify(b)
}
